export default {
  id: 'payroll',
  title: 'Payroll',
  category: 'Admin',
  summary: 'Review payroll periods and detailed earnings, tax, and deduction breakdowns.',
  overview: 'Payroll pages list payroll periods and open into detailed breakdowns. When Paylocity is connected, payroll data may be imported or scheduled from the integrations area.',
  howItWorks: [
    'Payroll periods aggregate employee compensation for a date range.',
    'Detail views break down earnings, taxes, and related amounts.',
    'Integration workflows can populate or sync this data from external payroll systems.'
  ],
  actions: [
    {
      name: 'Open a payroll period',
      description: 'Shows the detailed breakdown for that period.'
    },
    {
      name: 'Review breakdown categories',
      description: 'Inspect earnings, taxes, and other components used for accounting and reconciliation.'
    }
  ],
  tips: [
    'Employee mapping in Paylocity should be complete before relying on imported payroll figures.',
    'Use QuickBooks payroll expense mapping if you post payroll costs to accounting.'
  ],
  related: ['paylocity', 'employees', 'quickbooks']
};



// WEBPACK FOOTER //
// ./client/help/content/payroll.js